export default function addScript(url: string) {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    return;
  }

  const scriptTag = document.createElement('script');
  scriptTag.type = 'text/javascript';
  // Use 'anonymous' for CORS (allows wildcard Access-Control-Allow-Origin)
  // Scripts don't need credentials; only API calls do
  scriptTag.crossOrigin = 'anonymous';
  scriptTag.src = url;
  document.head.appendChild(scriptTag);
}
